// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".OrderSummaryRedirectToOrder-module-orderSummaryRedirectToOrder-f-a6w{display:flex;align-items:center;gap:4px;gap:var(--spacing-5xs, 4px);justify-content:flex-end;width:100%}.OrderSummaryRedirectToOrder-module-text-9Y8zM{font-size:12px;font-size:var(--size-text-xs, 12px);font-weight:400}@media(min-width: 960px){.OrderSummaryRedirectToOrder-module-text-9Y8zM{font-size:14px;font-size:var(--size-text-small, 14px)}}.OrderSummaryRedirectToOrder-module-link-bv2BS{text-decoration:none;color:#2d2926;display:flex;align-items:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"orderSummaryRedirectToOrder": "OrderSummaryRedirectToOrder-module-orderSummaryRedirectToOrder-f-a6w",
	"text": "OrderSummaryRedirectToOrder-module-text-9Y8zM",
	"link": "OrderSummaryRedirectToOrder-module-link-bv2BS"
};
export default ___CSS_LOADER_EXPORT___;
